module.exports = __webpack_public_path__ + "static/media/logo.6f726015.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.svg
// module id = 195
// module chunks = 0